export const queryMixin = {
  methods: {
    replaceCurrentRoutePath(obj) {
      if (Object.keys(obj).length <= 0) return
      let urlArr = window.location.href.split('?') || []
      let queryString1 = urlArr[0] || ''
      let queryString2 = urlArr[1] || ''
      let paramsObj = {}

      if (queryString2 !== '') {
        queryString2.split('&').forEach((keyValuePair) => {
          const [key, value] = keyValuePair.split('=')
          paramsObj[key] = value || ''
        })
      }

      const finalObject = { ...paramsObj, ...obj }
      Object.keys(finalObject).forEach((item, index) => {
        if (index === 0) {
          queryString1 += `?${item}=${finalObject[item]}`
        }
        //
        else {
          queryString1 += `&${item}=${finalObject[item]}`
        }
      })
      history.replaceState(null, null, queryString1)
    },
  },
}
